module.exports = __webpack_public_path__ + "static/img/logo.83c1edce.svg";